import { V2L3DatabaseModal } from "@fusion-advantage/formrender"
import { useAppDispatch } from "../../../redux/hooks"
import { useCallback, useEffect, useState } from "react"
import { AppModal, dismissAppModal } from "../../../redux/appSlice"
import { selectEntityNames } from "../../../dal/LdbBrowser"
import { appError } from "../../../redux/errorSlice"
import { V2L3DatabaseModalEntity } from "@fusion-advantage/formrender"
import { selectAllApptEncounterJson } from "../../../dal/ldbApptEncounter"
import { selectAllDrugProductText } from "../../../dal/ldbDrugProduct"
import { selectAllDrugProductMapText } from "../../../dal/ldbDrugProductMap"
import { selectAllDrugSearchWordText } from "../../../dal/ldbDrugSearchWord"
import { selectAllDrugIcdText } from "../../../dal/ldbDrugIcd"
import { selectAllUnfilteredIcdText } from "../../../dal/ldbUnfilteredIcd"
import { sleep } from "@fusion-advantage/formlib"
import { selectAllSettingText } from "../../../dal/ldbSetting"
import { selectAllMigrationJson } from "../../../dal/ldbMigrations"
import { selectAllMaterialClaimText, selectAllMaterialInventoryText } from "../../../dal/ldbMaterial"
import { selectCloudToDeviceBlobPreview, selectCloudToDeviceBlobStrKeys } from "../../../dal/ldbCloudToDeviceBlob"
import { selectDeviceToCloudBlobPreview, selectDeviceToCloudBlobStrDiscriminators } from "../../../dal/ldbDeviceToCloudBlob"

export const LxDatabaseModal = () => {
	const [loading, setLoading] = useState(false)
	const [entities, setEntities] = useState<V2L3DatabaseModalEntity[]>([])
	const [content, setContent] = useState<string>('')
	const dispatch = useAppDispatch()
	const handleEntityClick = useCallback(async (e: React.MouseEvent<HTMLAnchorElement>, entityName: string) => {
		e.preventDefault()
		setContent('')
		await sleep(10)
		switch(entityName) {
			case 'apptEncounter':
				setContent(await selectAllApptEncounterJson())
				return
			case 'drugProduct':
				setContent(await selectAllDrugProductText())
				return
			case 'drugProductMap':
				setContent(await selectAllDrugProductMapText())
				return
			case 'drugSearchWord':
				setContent(await selectAllDrugSearchWordText())
				return
			case 'drugIcd':
				setContent(await selectAllDrugIcdText())
				return
			case 'materialClaim':
				setContent(await selectAllMaterialClaimText())
				return
			case 'materialInventory':
				setContent(await selectAllMaterialInventoryText())
				return
			case 'migration':
				setContent(await selectAllMigrationJson())
				return
			case 'setting':
				setContent(await selectAllSettingText())
				return
			case 'unfilteredIcd':
				setContent(await selectAllUnfilteredIcdText())
				return
		}
		setContent(`no preview for ${entityName}`)
	}, [setLoading, setContent])
	const handleObjectClick = useCallback(async (e: React.MouseEvent<HTMLAnchorElement>, entityName: string, objectId: string) => {
		e.preventDefault()
		switch(entityName) {
			case 'cloudToDeviceBlob':
				setContent(await selectCloudToDeviceBlobPreview(objectId))
				return
			case 'deviceToCloudBlob':
				setContent(await selectDeviceToCloudBlobPreview(objectId))
				return
		}
		setContent(`no preview for ${entityName} ${objectId}`)
	}, [setContent])
	useEffect(() => {
		(async () => {
			const r = await selectEntityNames()
			if(r.isErr()) {
				dispatch(appError({
					err: r.error,
				}))
				return
			}
			const rCloudToDevice = await selectCloudToDeviceBlobStrKeys()
			const rDeviceToCloud = await selectDeviceToCloudBlobStrDiscriminators()
			const entities: V2L3DatabaseModalEntity[] = r.value.map(name => {
				let objectIds: string[] = []
				switch(name) {
					case 'cloudToDeviceBlob':
						if(rCloudToDevice.isOk()) {
							objectIds = rCloudToDevice.value
						}
						break
					case 'deviceToCloudBlob':
						if(rDeviceToCloud.isOk()) {
							objectIds = rDeviceToCloud.value
						}
						break
				}
				return { name, objectIds }
			})
			setEntities(entities)
		})()
	}, [dispatch, setEntities])
	return (
		<V2L3DatabaseModal
			entities={entities}
			content={content}
			onEntityClick={handleEntityClick}
			onObjectClick={handleObjectClick}
			onDismissClick={() => dispatch(dismissAppModal(AppModal.Database))}
		/>
	)
}
